<template>
    <div class="footer">
        <div class="cus-row">

            <div class="cus-row-col-4" @click="showlist">
                <div class="t-al-c"><van-icon name="wap-home-o" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">概览</span></div>
            </div>


          

            <div class="cus-row-col-4" style="position: relative">
<!--                <div class="add-btn"></div>-->
                <div class="add-btn f-c-000000" style="color:#ffffff !important;background-color: #0a0701" @click="addNew">
                    <span class="ab-t-t-x-y">
                        <van-icon name="plus" size="0.32rem"/>
                    </span>
                </div>
                <div class="t-al-c"><span class="ffr s-20-28 f-c-b5b5b5">新增收款</span></div>

            </div>


            <div class="cus-row-col-4" @click="showDone">
                <div class="t-al-c"><van-icon name="orders-o" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">列表</span></div>
            </div>

            <!-- <div class="cus-row-col-in-5" @click="showqr">
                <div class="t-al-c"><van-icon name="qr" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">员工管理</span></div>
            </div>

            <div class="cus-row-col-in-5" @click="showhome">
                <div class="t-al-c"><van-icon name="user-o" size="0.44rem"/></div>
                <div class="t-al-c" style="margin-top: .1rem"><span class="ffr s-20-28 f-c-b5b5b5">我的</span></div>
            </div> -->

        </div>




        <van-popup
                v-model="show"
                position="bottom"
                closeable
                close-icon-position="top-right"
                :style="{ height: 'auto' }"
                :close-on-click-overlay="false"
                ref="pop"
        >
            <div style="background-color: #ffffff;padding: 0.72rem .48rem .48rem .48rem">
                <div class="wx-text">微信扫一扫，查询质保</div>

                <div style="margin-top: 0.16rem;font-family: PingFangSC-Regular;font-size: 0.28rem;font-weight: normal;color: #222222;">
                    请向客户出示此二维码，长按图片/截屏保存到相册
                </div>


                <div style="padding: 0.14rem 0.16rem 0.18rem 0.16rem;border-radius: 0.16rem;margin-top: 0.48rem;text-align: center;">
                  <img :src="$common.polishingImg('/index/mini-wechat-pic')" style="display: inline-block;max-width: 80%;"/>
                </div>

            </div>
        </van-popup>


    <!-- start of 分配代理 -->
    <div
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99999;
      "
      class="t-al-c"
      v-if="owner_delegate_show"
    >
      <div
        style="
          position: absolute;
          background: rgba(26, 26, 26, 0.85);
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
        "
      ></div>
      <div
        class="ab-t-t-x-y"
        style="
          width: 300px;
          min-height: 100px;
          background: #ffffff;
          border-radius: 12px;
          overflow: hidden;
        "
      >
        <div
          role="dialog"
          aria-labelledby="标题"
          class=""
          style="z-index: 2003"
        >
          <div class="van-dialog__header" style="font-size: 14px;">选择模板类型</div>
          <div class="van-dialog__content">
            <div style="margin: 20px 0; padding: 0 20px">
              <van-radio-group v-model="contract_type">
                <van-radio name="A00001" style="margin-bottom: 12px; font-size: 14px;">
                  境内游合同
                </van-radio>
                <van-radio name="C00001" style="margin-bottom: 12px; font-size: 14px;">
                  出境游合同
                </van-radio>
                <van-radio name="E00001" style="font-size: 14px;">
                  代订代办合同
                </van-radio>
              </van-radio-group>
            </div>
          </div>
          <div
            class="van-hairline--top van-dialog__footer van-dialog__footer--buttons"
          >
            <button
              class="van-button van-button--default van-button--large van-dialog__cancel"
              @click="cancelSetDelegate"
            >
              <span class="van-button__text">取消</span></button
            ><button
              class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left"
              @click="confirmSetDelegate"
            >
              <span class="van-button__text">确认</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- start of 分配代理 -->


    </div>
</template>

<script>
    import common from "@/assets/js/common"
    import UrlParse from 'url-parse'

    export default {
        data:function () {
            return {
                show:false,
                edu_name:'',
                qrcodePath: common.dynamicHost() + '/entry_qrcode.png',
                owner_delegate_show: false,
                contract_type: ""
            }
        },
        created () {

        },
        methods: {
            cancelSetDelegate(){
                this.owner_delegate_show = false
            },

            confirmSetDelegate(){
                // this.owner_delegate_show = false
                if( !this.contract_type ){
                    common.mAlert(this, "请选择模板")
                    return
                }

                this.owner_delegate_show = false

                //TODO 
                common.cusHttp(this, "/admin_user.php?action=add_or_modify_job", {contract_type: this.contract_type}, "post").then((res) => {
                    console.log("user_info返回", res)
                    res = JSON.parse(res.data)
                    if (res.errcode == 0) {
                        // this.user = res.result
                        // console.log(JSON.stringify(res.data.loan_list));
                        // this.list = res.data.loan_list;
                        this.$router.push({ path: "new_invoice?id=" + res.data });
                    }
                });
            },
            addNew()
            {
                this.$router.push({ path: "/new_collection" })
            },
            showqr()
            {
                // this.$emit('showqr',{});
                // this.show = true;
                // common.mAlert(this, "功能暂未开放")


               this.$router.push({path: "invoice"})

            },
            showlist()
            {
              this.$router.push({ path: "/collection_list" });
            },
            showhome()
            {
                // location.href = 'sa_home'
              this.$router.push({ path: "mine" });
            },
            showDone()
            {
              this.$router.push({ path: "/collection_list" });
            }
        },
        mounted() {
            // common.eduInfo().then((res)=>{
            //     if( res.data.errcode == 0 )
            //     {
            //         this.edu_name = res.data.edu_name
            //     }
            // })
        }
    }
</script>

<style scoped>
    .footer{
        position: fixed;
        z-index: 99;
        left: 50%;
        right: auto;
        transform: translateX(-50%);
        width: 100%;
        max-width: 760px;
        bottom: 0;
        box-shadow: 0.03rem -0.05rem 0.43rem 0.02rem
        rgba(0, 0, 0, 0.06);
        padding: 0.12rem 0;
        background-color: #ffffff;
    }

    /* 当屏幕宽度小于等于760px时，占满全屏 */
    @media (max-width: 760px) {
        .footer {
            left: 0 !important;
            right: 0 !important;
            transform: none !important;
            max-width: 100% !important;
        }
    }


    .add-btn{
        position: absolute;
        width: 0.8rem;
        height: 0.8rem;
        background-color: #1889f9;
        box-shadow: 0.03rem 0.05rem 0.43rem 0.02rem
        rgba(24, 137, 249, 0.24);
        border-radius: 0.6rem;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        bottom: .4rem;
    }
</style>
